import React from 'react';
import classNames from 'classnames';
import { Button, IconButton } from 'Permafrost/index';
import { StyledTag } from './Tag.styles';
export const Tag = (props) => {
    const { disabled, selected, value, onClick, onRemove } = props;
    return (React.createElement(StyledTag, { className: classNames('Tag--container', { selected }), "data-testid": props['data-testid'] },
        onClick ? (React.createElement(Button, { className: "value-select", onClick: onClick }, value)) : (React.createElement(React.Fragment, null, value)),
        React.createElement(IconButton, { isDisabled: disabled, className: "remove-btn", iconName: "x-close", onPress: onRemove })));
};
//# sourceMappingURL=Tag.js.map